import { Component, Output } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { UpgradeDialogComponent } from './upgrade-dialog/upgrade-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { CancelSubsciptionComponent } from './cancel-subsciption/cancel-subsciption.component';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrl: './subscription.component.scss',
  standalone: false
})
export class SubscriptionComponent {
  plan_update: any;
  pricingData: any[] = [];
  user_subscription_plans: any[] = [];
  user_subscription_plans_table: any[] = [];
  get_user_subscription_plan?: number;
  subscription_plan_features: any[] = [];
  subscription_end_date: any;
  errorMessage: any;
  paymentMethods: any[] = [];
  loading: boolean = true;
  displayedColumns: string[] = ['listners_count'];
  UUID: any;
  check_subscription_plan: any;
  plan: any;
  showDashboarddefaultMethod: any[] = [];
  hightlighted_row: any;
  loadingListenersCount: any;
  total_listeners: any;
  pricePerListen: any;
  currentTierCount: any;
  will_cancel_at_end_of_period: number = -1
  constructor(
    private dialog: MatDialog,
    private authService: AuthService,
    private userService: UserService
  ) { };
  ngOnInit() {
    this.getUsersSubscriptionPlans();
    this.authService.token.subscribe((token: any) => {
      this.UUID = token.UUID
    });

  }
  getUsersSubscriptionPlans() {
    this.userService.getsubscriptionplans().subscribe((result) => {
      this.plan_update = result?.sub_results?.[0]?.subscription_status || null;
      this.loading = false;
      this.user_subscription_plans = result.plans.map((p: { name: string; }) => {
        let value = 0;
        if (p.name === 'pyrocast hobbyist') value = 0;
        else if (p.name === 'ignite hobbyist') value = 1;
        else if (p.name === 'tune2 hobbyist') value = 2;
        return { ...p, value };
      });

      this.user_subscription_plans_table = this.user_subscription_plans.filter(p => p.name !== 'Test Based Hobbyist');
      this.check_subscription_plan = result.userSubscription;
      this.showDashboarddefaultMethod = [result.userSubscription];
      this.subscription_plan_features = result.features;
      this.pricingData = result.dynamicPricing;
      this.get_user_subscription_plan = result.userSubscription.subscription_plan;
      this.hightlighted_row = this.get_user_subscription_plan;
      this.subscription_end_date = result.userSubscription.subscription_end_date;
      this.will_cancel_at_end_of_period = result.userSubscription.will_cancel_at_end_of_period
      this.displayedColumns = [
        'listners_count',
        ...this.user_subscription_plans_table.map(plan => plan.name)
      ];
    });
  }



  subscribe(plan: string) {

    const dialogRef = this.dialog.open(PaymentSuccessComponent, {
      width: '600px',
      data: { SubscriptionPlan: plan, errorMessage: this.errorMessage, check_subscription_plan: this.check_subscription_plan, plan_update: this.plan_update }
    });
    dialogRef.afterClosed().subscribe((result) => {
      setTimeout(() => {
        this.getUsersSubscriptionPlans();
      }, 3000); // 3 sec (tune based on testing)
    });
  }
  showUpgradeMessage() {
    this.dialog.open(UpgradeDialogComponent);
  }
  caneclSubscription(value: string) {
    const dialogRef = this.dialog.open(CancelSubsciptionComponent, {
      width: '600px',
      data: { SubscriptionPlan: value, UUID: this.UUID, subscription_end_date: this.subscription_end_date }
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getUsersSubscriptionPlans();
    });
  }

}
